import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './Contact.css';
import contactImg from '../../../Assets/contact.svg';
import Fade from 'react-reveal/Fade';
import swal from 'sweetalert';

const Contact = () => {
    const handleSubmit = event => {
        event.preventDefault();

        const form = event.target;

        const name = form.name.value;
        const email = form.email.value;
        const subject = form.subject.value;
        const message = form.message.value;

        const whatsappMessage = `Hello NextGen Nexus,%0A%0AName: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;

        window.open(`https://wa.me/919024711288?text=${whatsappMessage}`, '_blank');

        swal("Thank You!", "We received your message. Our team will contact you soon.", "success");

        form.reset();
    };

    return (
        <section id="contact">
            <Col md={11} className="mx-auto">
                <Row className="align-items-center">
                    <Col md={6}>
                        <Fade duration={2000} left>
                            <form onSubmit={handleSubmit} className="contactForm">
                                <h4 className="miniTitle">Contact Us</h4>
                                <h5 className="sectionTitle">Let’s Build Something Great</h5>

                                <Row>
                                    <Col md={12} lg={6}>
                                        <input name="name" placeholder="Your Name" type="text" required />
                                    </Col>

                                    <Col md={12} lg={6}>
                                        <input name="email" placeholder="Your Email" type="email" required />
                                    </Col>

                                    <Col md={12}>
                                        <input name="subject" placeholder="Project / Service Type" type="text" required />
                                    </Col>

                                    <Col md={12}>
                                        <textarea name="message" placeholder="Tell us about your requirement..." required></textarea>
                                    </Col>
                                </Row>

                                <button className="branBtn" type="submit">
                                    Send Message
                                </button>
                            </form>
                        </Fade>
                    </Col>

                    <Col md={6}>
                        <Fade duration={2000} right>
                            <img src={contactImg} alt="Contact NextGen Nexus" className="img-fluid" />
                        </Fade>
                    </Col>
                </Row>
            </Col>
        </section>
    );
};

export default Contact;